export function redirect (path) {
  window.location.replace(`#/${path}`)
}
